import React from 'react';
import './Privacy.css';
import { useI18n, usePageTitle } from './i18n';

function renderBlock(block, key) {
  if (block.type === 'paragraph') {
    return <p key={key}>{block.content}</p>;
  }

  if (block.type === 'list') {
    return (
      <ul key={key}>
        {block.items.map((item, index) => (
          <li key={`${key}-${index}`}>{item}</li>
        ))}
      </ul>
    );
  }

  if (block.type === 'subheading') {
    return <h3 key={key}>{block.content}</h3>;
  }

  return null;
}

export default function LegalPage({ pageKey }) {
  const { messages } = useI18n();
  const page = messages.pages[pageKey];

  usePageTitle(page.metaTitle || page.title);

  return (
    <div className="privacy-container">
      <header className="privacy-header">
        <h1>{page.title}</h1>
        <p className="privacy-subtitle">{page.subtitle}</p>
      </header>
      <main className="privacy-main">
        {(page.blocks || []).map((block, index) => renderBlock(block, `intro-${index}`))}

        {(page.sections || []).map((section, index) => (
          <section key={`${pageKey}-${index}`}>
            {section.title ? <h2>{section.title}</h2> : null}
            {section.blocks.map((block, blockIndex) =>
              renderBlock(block, `${pageKey}-${index}-${blockIndex}`)
            )}
          </section>
        ))}

        {(page.footerBlocks || []).map((block, index) => renderBlock(block, `footer-${index}`))}
      </main>
    </div>
  );
}
